import HTTPHeader from "@components/HTTPHeader";
import * as React from 'react';
export default {
  HTTPHeader,
  React
};